import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
import { GetAllchannalData } from '../Redux/Actions/ChannalActions';
import { GetallProjectsdata } from '../Redux/Actions/Projects_Action';
import BeenhereIcon from '@mui/icons-material/Beenhere';
import { Switch, TextField } from '@mui/material';
import { Notify } from '../Utility/Notify';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import { GetOne_Rotation_Data, UpdateOne_Rotation_Data } from '../Redux/Actions/Rotations_Actions';
import { useTheme } from '@mui/material/styles';

const ITEM_HEIGHT = 130;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
export const EditRotationPage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const theme = useTheme();
  const mode = theme.palette.mode; // جلب الوضع الحالي (dark / li

  // sales

  const getAll = async () => {
    await dispatch(Get_All_Sales_Action());
    await dispatch(GetAllchannalData());
    await dispatch(GetallProjectsdata());
  };

  useEffect(() => {
    getAll();
  }, []);

  const getonerotation = async () => {
    await dispatch(GetOne_Rotation_Data(id));
  };

  useEffect(() => {
    getonerotation();
  }, []);

  const resallsales = useSelector((state) => state.AllSales.sales);
  const reschannel = useSelector((state) => state.AllChannalRoot.channal);
  const resAllProjects = useSelector((state) => state.AllProjects.Projects);
  const resgetonerotationdata = useSelector((state) => state.AllRotation.Rotation);

  let allsales = Array.isArray(resallsales?.data) ? resallsales.data : [];
  let allChannel = Array.isArray(reschannel?.data) ? reschannel.data : [];
  let allProjects = Array.isArray(resAllProjects?.data) ? resAllProjects.data : [];

  // let selectedrotation = Array.isArray(resgetonerotationdata?.data) ? resgetonerotationdata.data : [];

  const [selectedrotation, setSelectedRotation] = useState([]);

  const [personName, setPersonName] = React.useState([]);
  const [chanelname, setchanelname] = React.useState([]);
  const [projectname, setprojectname] = React.useState([]);
  const [loading, setloading] = useState(true);
  const [rotationtime, setrotationtime] = useState(0);

  useEffect(() => {
    if (resgetonerotationdata && resgetonerotationdata.data) {
      setSelectedRotation(resgetonerotationdata.data);
      // console.log("🟡 Full selectedrotation Data:", resgetonerotationdata.data);
    } else {
      setSelectedRotation([]);
      console.log('❌ No Rotation Data Found');
    }
  }, [resgetonerotationdata]);

  useEffect(() => {
    if (selectedrotation && selectedrotation.sales) {
      const extractedSales = selectedrotation.sales.map(
        (sale) => sale.salesId?._id || sale.salesId,
      );
      // console.log("✅ Extracted Sales IDs:", extractedSales);

      const validSales = extractedSales.filter((id) =>
        allsales.some((salesitem) => salesitem._id === id),
      );

      // console.log("✅ Valid Sales IDs:", validSales);

      setPersonName(validSales);
    } else {
      console.log('❌ No Sales Data Found in Rotation');
    }
    if (selectedrotation.channels && Array.isArray(selectedrotation.channels)) {
      const extractedChannels = selectedrotation.channels.map((channel) => channel._id);
      // console.log("✅ Extracted Channel IDs:", extractedChannels);

      const validChannels = extractedChannels.filter((id) =>
        allChannel.some((channelitem) => channelitem._id === id),
      );

      // console.log("✅ Valid Channel IDs:", validChannels);
      setchanelname(validChannels);
    } else {
      console.log('❌ No Channels Data Found in Rotation');
    }

    // استخراج الـ Projects
    if (selectedrotation.projects && Array.isArray(selectedrotation.projects)) {
      const extractedProjects = selectedrotation.projects.map((project) => project._id);
      // console.log("✅ Extracted Project IDs:", extractedProjects);

      const validProjects = extractedProjects.filter((id) =>
        allProjects.some((projectitem) => projectitem._id === id),
      );

      // console.log("✅ Valid Project IDs:", validProjects);
      setprojectname(validProjects);
    } else {
      console.log('❌ No Projects Data Found in Rotation');
    }
  }, [selectedrotation, allsales, allProjects, allChannel]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  // ===================================================================================
  // channel

  const handlechanelChange = (event) => {
    const {
      target: { value },
    } = event;
    setchanelname(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };
  // console.log(chanelname,"chanel")

  // ///////////////////////////////////////////////////////////////
  // Projects

  const handleprojectChange = (event) => {
    const {
      target: { value },
    } = event;
    setprojectname(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };
  // console.log(projectname,"project")

  // =====================================================================

  const handlerotationtime = (e) => {
    setrotationtime(e.target.value);
  };

  // switch active or not active
  const [checked, setChecked] = React.useState(true);
  const handleChangeswitch = (event) => {
    setChecked(event.target.checked);
  };
  const updateRotation = async (e) => {
    if (rotationtime === 0) {
      Notify('error', 'Rotation Time  Is Required', 'error');
      return;
    } else if (personName.length === 0) {
      Notify('error', 'Sales Name Is Required', 'error');
      return;
    } else if (chanelname.length === 0) {
      Notify('error', 'Channel Name Is Required', 'error');
      return;
    } else if (projectname.length === 0) {
      Notify('error', 'Project Name Is Required', 'error');
      return;
    }

    e.preventDefault();
    setloading(true);

    try {
      // تضمين maxLeads مع كل salesId
      const salesWithMaxLeads = personName.map((salesId) => ({
        salesId: salesId, // salesId هو الـ ObjectId الخاص بـ Sales
        maxLeads: rotationtime, // القيمة المحددة لـ maxLeads، ويمكن تعديلها حسب الحاجة
        assignedLeads: 0, // قيمة البداية لـ assignedLeads
      }));

      await dispatch(
        UpdateOne_Rotation_Data(id, {
          sales: salesWithMaxLeads, // إرسال الـ sales مع maxLeads
          channels: chanelname, // القناة المختارة
          projects: projectname, // المشروع المختار
          active: checked,
        }),
      );
    } catch (error) {
      console.error('Error adding rotation:', error);
    } finally {
      setloading(false);
    }
  };

  const resallrotation = useSelector((state) => state.AllRotation.UpdateRotation);

  useEffect(() => {
    if (loading === false) {
      if (resallrotation && resallrotation.status === 200) {
        Notify('success', 'Rotation Added Successfully', 'success');
      } else {
        Notify('error', 'Failed to Add Rotation', 'error');
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      }
    }
  }, [loading]);

  // تحديد كل ال projects
  const selectAllProjects = () => {
    // نقوم بتحديد كل المشاريع هنا
    const allProjectIds = allProjects.map((project) => project._id); // استخراج كل الـ ID للمشاريع
    setprojectname(allProjectIds); // تعيين كل الـ ID في الـ state
    setshowcancelproject(true);
  };

  //   تحديد كل ال channels
  const selectAllchannels = () => {
    const allchannelsIds = allChannel.map((channel) => channel._id); // استخراج كل الـ ID للمشاريع
    setchanelname(allchannelsIds); // تعيين كل الـ ID في الـ state
    setshowcancelchannel(true);
  };

  //   تحديد كل ال sales
  const selectAllsales = () => {
    const allsalesIds = allsales.map((sales) => sales._id); // استخراج كل الـ ID للمشاريع
    setPersonName(allsalesIds); // تعيين كل الـ ID في الـ state
    setShowCancelSales(true);
  };

  const [showCancelSales, setShowCancelSales] = React.useState(false);
  const [showcancelchanel, setshowcancelchannel] = React.useState(false);
  const [showcancelproject, setshowcancelproject] = React.useState(false);

  // cancel sales
  const cancelSales = () => {
    setPersonName([]);
    setShowCancelSales(false);
  };

  // cancel channel
  const cancelchannel = () => {
    setchanelname([]);
    setshowcancelchannel(false);
  };

  // cancel project
  const cancelproject = () => {
    setprojectname([]);
    setshowcancelproject(false);
  };
  return (
    <Container className="startpage">
      <Row>
        <Col sm={0}></Col>
        <Col sm={12}>
          <Link to={`/AllLeadsForAdmin`} style={{ textDecoration: 'none', color: '#0F7687' }}>
            <span style={{ fontWeight: 'bold' }}>Home</span>
          </Link>{' '}
          <KeyboardDoubleArrowRightIcon />{' '}
          <Link
            to={`/Rotation`}
            style={{ textDecoration: 'none', color: mode === 'dark' ? '#90caf9' : '#0F7687' }}
          >
            <span>Rotation</span>
          </Link>{' '}
          <KeyboardDoubleArrowRightIcon /> <span>Edit Rotation</span>
          <div className="d-flex justify-content-between flex-wrap my-4 rotationcontainer">
            <div className="rotationcontainer">
              <div
                className="btn btn-error rotationbtn"
                style={{ background: '#0F7687' }}
                onClick={selectAllsales}
              >
                All Sales
              </div>

              <div
                className="btn btn-error rotationbtn"
                style={{ background: '#0F7867' }}
                onClick={selectAllchannels}
              >
                All Chanels
              </div>
              <div
                className="btn btn-error  rotationbtn"
                style={{ background: '#0F7677' }}
                onClick={selectAllProjects}
              >
                All Projects
              </div>
            </div>

            <Link to={`/manageRotation`} style={{ textDecoration: 'none' }}>
              <div className="btn btn-error rotationbtn " style={{ background: 'royalblue' }}>
                Manage Rotations <ManageHistoryIcon />
              </div>
            </Link>
          </div>
          <div className="d-flex justify-content-start flex-wrap">
            {/* cancel sales */}
            {showCancelSales && (
              <div
                className="btn btn-warning rotationbtn mx-2"
                style={{ background: '#FF5733', marginTop: '10px' }}
                onClick={cancelSales}
              >
                Cancel Sales {`${allsales.length}`} Selected
              </div>
            )}
            {/* ================================= */}
            {/* cancel channel */}

            {showcancelchanel && (
              <div
                className="btn btn-warning rotationbtn mx-2"
                style={{ background: '#FF5733', marginTop: '10px' }}
                onClick={cancelchannel}
              >
                Cancel Channel {`${allChannel.length}`} Selected
              </div>
            )}

            {/* ========================== */}

            {/* cancel project */}
            {showcancelproject && (
              <div
                className="btn btn-warning rotationbtn mx-2"
                style={{ background: '#FF5733', marginTop: '10px' }}
                onClick={cancelproject}
              >
                Cancel Projects {`${allProjects.length}`} Selected
              </div>
            )}
          </div>
          <br />
          <label className="m-3">Rotation Time :</label>
          <br />
          <TextField
            className="mx-1"
            required
            id="outlined-required"
            label="Rotation Times Required"
            defaultValue=""
            type="number"
            value={rotationtime}
            onChange={handlerotationtime}
          />
          {/* sales */}
          <div>
            <FormControl sx={{ m: 1, width: '100%' }}>
              <InputLabel id="demo-multiple-checkbox-label">Choose Sales</InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={personName} // تحتوي على IDs
                onChange={handleChange}
                input={<OutlinedInput label="Tag" />}
                renderValue={(selected) =>
                  selected
                    .map((id) => {
                      const selectedItem = allsales.find((item) => item._id === id);
                      return selectedItem ? selectedItem.name : '';
                    })
                    .join(', ')
                }
                MenuProps={MenuProps}
              >
                {allsales.map((salesitem) => (
                  <MenuItem key={salesitem._id} value={salesitem._id}>
                    <Checkbox checked={personName.includes(salesitem._id)} />
                    <ListItemText
                      primary={salesitem.name}
                      secondary={salesitem?.userlog?.role || 'No role'}
                      secondaryTypographyProps={{
                        style: {
                          fontSize: '0.75rem',
                          color: '#666',
                        },
                      }}
                    />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          {/* ==================================================== */}
          {/* chanel */}
          <div>
            <FormControl sx={{ my: 3, mx: 1, width: '100%' }}>
              <InputLabel id="demo-multiple-checkbox-label">Choose Channel</InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={chanelname} // قيمة الـ ID هنا
                onChange={handlechanelChange}
                input={<OutlinedInput label="Tag" />}
                renderValue={
                  (selected) =>
                    selected
                      .map((id) => {
                        // عرض الـ name بناءً على الـ ID
                        const selectedItem = allChannel.find((item) => item._id === id);
                        return selectedItem ? selectedItem.name : '';
                      })
                      .join(', ') // دمج الأسماء مع الفاصلة بين كل عنصر
                }
                MenuProps={MenuProps}
              >
                {allChannel.map((channelitem) => (
                  <MenuItem key={channelitem._id} value={channelitem._id}>
                    <Checkbox checked={chanelname.includes(channelitem._id)} />
                    <ListItemText primary={channelitem.name} />{' '}
                    {/* المعروض في الواجهة هو الـ name */}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          {/* ============================================================= */}
          {/* projects */}
          <div>
            <FormControl sx={{ mx: 1, width: '100%' }}>
              <InputLabel id="demo-multiple-checkbox-label">Choose Project</InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={projectname} // قيمة الـ ID هنا
                onChange={handleprojectChange}
                input={<OutlinedInput label="Tag" />}
                renderValue={
                  (selected) =>
                    selected
                      .map((id) => {
                        // عرض الـ name بناءً على الـ ID
                        const selectedItem = allProjects.find((item) => item._id === id);
                        return selectedItem ? selectedItem.name : '';
                      })
                      .join(', ') // دمج الأسماء مع الفاصلة بين كل عنصر
                }
                MenuProps={MenuProps}
              >
                {allProjects.map((projectitem) => (
                  <MenuItem key={projectitem._id} value={projectitem._id}>
                    <Checkbox checked={projectname.includes(projectitem._id)} />
                    <ListItemText primary={projectitem.name} />{' '}
                    {/* المعروض في الواجهة هو الـ name */}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div
            className="d-flex justify-content-center my-3"
            style={{ textAlign: 'center', alignItems: 'center' }}
          >
            <div>Activation</div>
            <Switch
              checked={checked}
              onChange={handleChangeswitch}
              inputProps={{ 'aria-label': 'controlled' }}
            />
            {checked === true ? <div>Active</div> : <div>Not Active</div>}
          </div>
          <div
            onClick={updateRotation}
            className="w-100 btn btn-primary mx-2  my-4"
            style={{ background: '#0F7687', border: 'none' }}
          >
            Edit <BeenhereIcon />
          </div>
        </Col>
      </Row>
    </Container>
  );
};
